import { render, staticRenderFns } from "./UnloadingCargos.vue?vue&type=template&id=c6d55604&scoped=true&"
import script from "./UnloadingCargos.vue?vue&type=script&lang=js&"
export * from "./UnloadingCargos.vue?vue&type=script&lang=js&"
import style0 from "./UnloadingCargos.vue?vue&type=style&index=0&id=c6d55604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d55604",
  null
  
)

export default component.exports